import React from "react";
import { Text, Layout, TabHeader, Heading, Button } from "@netapp/bxp-design-system-react"
import { useLocation } from "react-router-dom";

class ErrorHandler extends React.Component {
    constructor(props: any) {
        super(props);
        this.state = { hasError: false };
    }
    // TabHeader = () => <div/>
    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error: any) {
        try{
            const stack = error.stack || '';
            const chunkSize = 90;
            const parts = stack.match(new RegExp(`.{1,${chunkSize}}`, 'g')) || [];
            console.log(import.meta.env.MODE)
            window.gtag('event', 'exception',
                {
                    'description': error.message,
                    'fatal': true,
                    'environment': import.meta.env.NODE_ENV,
                    'stage': import.meta.env.stage,
                    'stackTrace': error.stack,
                    stackTrace_p1: parts[0] || '',
                    stackTrace_p2: parts[1] || '',
                    stackTrace_p3: parts[2] || '',
                    'debug_mode': import.meta.env.MODE === "development"
                });
        } catch (error){
            console.error("Failed to log error to gtag", error);
        }
        try{
            window["FS"].event('exception',
                {
                    'description': error.message,
                    'fatal': true,
                    'environment': import.meta.env.NODE_ENV,
                    'stage': import.meta.env.stage,
                    'stackTrace': error.stack,
                    'errorMessage': error.message,
                });
        } catch (error){
            console.error("Failed to log error to FullStory", error);
        }
        console.error(error);
    }

    shouldComponentUpdate(nextProps: any, nextState: any) {
        return this.props.children !== nextProps.children || this.state.hasError !== nextState.hasError || this.state.hasError && this.props.pathname !== nextProps.pathname;
    }

    componentDidUpdate(prevProps: any, prevState: any, snapshot: any) {
        if (prevState.hasError && prevProps.pathname !== this.props.pathname) {
            this.setState({ hasError: false })
        }
    }

    render() {
        if (this.state.hasError) {
            return <Layout.Page>
                <TabHeader label="Failed to Render"/>
                <Layout.Content style={{ padding: "40px 0" }}>
                    <Layout.Column>
                        <Heading level={2}>
                            The tab or service has unexpectedly crashed.
                        </Heading>
                        <Text>
                            Error printed to console.
                        </Text>
                        <Text>If the error recurs please contact Support.</Text>

                        {import.meta.env.MODE === "development" && <Button color="secondary" onClick={() => {
                            this.setState({ hasError: false })
                        }}>
                            Reset
                        </Button>}
                    </Layout.Column>
                </Layout.Content>
            </Layout.Page>;
        }

        return this.props.children;
    }
}

const MainErrorBoundary = React.memo(({ children }) => {
    const location = useLocation();

    return <ErrorHandler pathname={location.pathname}>
        {children}
    </ErrorHandler>
});

export default MainErrorBoundary;